import React from 'react';
import {Alert} from 'reactstrap';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'My Customers ',
		url: '/customers',
		icon: 'users',
	},
	{
		name: 'NICS Denied',
		url: '/customers/nics_denies',
		icon: 'window-close-o',
	}
];

export default class Nics_Denies extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>

				<Alert color="warning">
					These customers have been denied on a NICS background check and were automatically added to the NICS Denied list. A warning will
					appear on any future dispositions unless they are removed from the list. An embossed overturn appeal certificate is required to
					run a background check for a person previously denied by NICS.
				</Alert>
				<Collections.NicsDenied
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>
				<hr/>
				<Alert color="warning">
					These customers have been manually blacklisted. A warning will appear on any future dispositions unless they are removed from the
					list.
				</Alert>
				<Collections.Blacklist
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"Blacklist"}
					object={Objects.CustomerBlacklist}
					history={this.props.history}
					toggle={this.state['modalCustomerBlacklist']}
					reportClose={this.reportClose('modalCustomerBlacklist')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}
